import { type TypographyProps, useTheme } from "@mui/material";

export const useNavigationHeaderTitleTypographyProps = (): TypographyProps => {
	const theme = useTheme();
	return {
		fontWeight: 700,
		fontSize: 16,
		color: theme.palette.grey[700],
		textOverflow: "ellipsis",
		overflow: "hidden",
		whiteSpace: "nowrap",
	};
};
